import React, { useContext } from 'react'
import styled from 'styled-components';
import { BookLayoutContext } from 'contexts/BookLayoutContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Anchor, Divider } from 'antd';

const ModelNavWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
    padding-left: ${props => props.$empty ? '2rem' : 0};
    padding-bottom: ${props => props.$empty ? '.5rem' : 0};

    .ant-anchor-wrapper {
        .ant-anchor {
            padding: 0;
            color: unset;
            font-size: unset;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            gap: 0;
            padding-left: .2rem;

            .ant-anchor-ink {
                display: none;
            }

            .playlist-link-wrapper {
                display: flex;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;

                .ant-anchor-link {
                    padding: 0;

                    .ant-anchor-link-title {
                        font-size: ${props => props.$compact ? '1rem' : '1.15rem'};
                        /* text-transform: capitalize; */

                        .note-link-wrapper {
                            display: flex;
                            flex-wrap: nowrap;
                            justify-content: flex-start;
                            align-items: center;
                            gap: .5rem;

                            em {
                                font-style: normal;
                            }
                            .icon-wrapper {
                                font-size: .9rem;
                            }
                        }

                    }

                    &.ant-anchor-link-active {
                        .ant-anchor-link-title {
                            font-weight: bold;
                        }
                    }
                }
                .ant-divider.ant-divider-vertical {
                    height: 1.4em;
                    top: 0;
                    border-left: 1px solid rgba(0, 0, 0, 0.1);
                    margin: 0 .5rem;
                }
            }
        }
    }
`

const PlaylistsNav = ({ model, compact }) => {

    const { headerHeight } = useContext(BookLayoutContext)

    if (!model || !model.Playlists || !model.Playlists.length) {
        return null
    }



    const hasMoreThanOnePlaylist = () => {
        return model && model.Playlists && (model.Playlists.length > 1 || (model.Note && model.Note.length > 0))
    }

    return (
        <ModelNavWrapper $empty={!hasMoreThanOnePlaylist()} $compact={compact}>
            <Anchor
                getContainer={() => document.querySelector("#modelPlaylistsWrapper")}
                targetOffset={headerHeight}
                affix={false}
            >
                {model.Playlists.map((mp, index) => (
                    <div className="playlist-link-wrapper" key={index}>
                        <Anchor.Link
                            href={`#playlist-${index}`}
                            title={mp.Name}
                        />
                        {(index < model.Playlists.length - 1) &&
                            <Divider type="vertical" />
                        }
                    </div>
                ))}
                {model && model.Note &&
                    <div className="playlist-link-wrapper" key={99999}>
                        <Divider type="vertical" />
                        <Anchor.Link
                            href={`#playlist-${hasMoreThanOnePlaylist() ? model.Playlists.length : 1}`}
                            title={
                                <div className="note-link-wrapper">
                                    <div className="icon-wrapper">
                                        <FontAwesomeIcon
                                            flip="horizontal"
                                            icon={icon({ name: 'message', family: 'classic', style: 'duotone' })}
                                        />
                                    </div>
                                    <em>notes</em>
                                </div>
                            }
                        />
                    </div>
                }
            </Anchor>
        </ModelNavWrapper>
    )
}

export default PlaylistsNav;
